import React from "react";

const Register = () => {
  return (
    <div className="container">
      <p>Register</p>
    </div>
  );
};

export default Register;